import { component as defineComponent } from 'flightjs';

function archiveButton() {
    this.attributes({
        archiveButton: '[data-archive-button-archive]',
        unarchiveButton: '[data-archive-button-unarchive]',
    });

    this.after('initialize', function () {
        this.on('click', this.toggleArchive);
    });

    this.archive = function () {
        this.$node.attr('data-archive-button-state', 'archived');
        this.select('archiveButton').attr('data-hidden', true);
        this.select('unarchiveButton').removeAttr('data-hidden');

        this.trigger(this.$node, 'uiContestArchiveRequested', {
            listingId: this.$node.attr('data-archive-button-listing-id'),
            endpoint: this.$node.attr('data-archive-button-archive-endpoint'),
        });
    };

    this.unarchive = function () {
        this.$node.attr('data-archive-button-state', 'unarchived');
        this.select('unarchiveButton').attr('data-hidden', true);
        this.select('archiveButton').removeAttr('data-hidden');

        this.trigger(this.$node, 'uiContestUnarchiveRequested', {
            listingId: this.$node.attr('data-archive-button-listing-id'),
            endpoint: this.$node.attr('data-archive-button-unarchive-endpoint'),
        });
    };

    this.toggleArchive = function (e) {
        e.preventDefault();

        if (this.$node.is('[data-archive-button-state="archived"]')) {
            this.unarchive();
        } else {
            this.archive();
        }
    };
}

export default defineComponent(archiveButton);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/archive-button.js